/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_No_TeamsInputs */

const th_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีทีม`)
};

const en_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teams.`)
};

const ja_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームがありません。`)
};

const zh_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无球队。`)
};

const es_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin equipos.`)
};

const pt_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum time.`)
};

const id_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada tim.`)
};

const fr_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune équipe.`)
};

const tl_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang team.`)
};

const vi_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có đội.`)
};

const ko_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀이 없습니다.`)
};

const de_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Teams.`)
};

const ru_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команд нет.`)
};

const tr_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takım yok.`)
};

const it_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna squadra.`)
};

const pl_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak drużyn.`)
};

const uk_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команд немає.`)
};

const hi_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई टीम नहीं।`)
};

const ar_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد فرق.`)
};

const ms_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada pasukan.`)
};

const bn_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনও দল নেই।`)
};

const zh_tw2_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有球隊。`)
};

const zh_hk2_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有球隊。`)
};

const ur_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی ٹیم نہیں۔`)
};

const fa_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیمی نیست.`)
};

const sw_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna timu.`)
};

const nl_admin_no_teams = /** @type {(inputs: Admin_No_TeamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen teams.`)
};

/**
* | output |
* | --- |
* | "No teams." |
*
* @param {Admin_No_TeamsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const admin_no_teams = /** @type {((inputs?: Admin_No_TeamsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_No_TeamsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_admin_no_teams(inputs)
	if (locale === "ja") return ja_admin_no_teams(inputs)
	if (locale === "zh") return zh_admin_no_teams(inputs)
	if (locale === "es") return es_admin_no_teams(inputs)
	if (locale === "pt") return pt_admin_no_teams(inputs)
	if (locale === "id") return id_admin_no_teams(inputs)
	if (locale === "fr") return fr_admin_no_teams(inputs)
	if (locale === "tl") return tl_admin_no_teams(inputs)
	if (locale === "vi") return vi_admin_no_teams(inputs)
	if (locale === "ko") return ko_admin_no_teams(inputs)
	if (locale === "de") return de_admin_no_teams(inputs)
	if (locale === "ru") return ru_admin_no_teams(inputs)
	if (locale === "tr") return tr_admin_no_teams(inputs)
	if (locale === "it") return it_admin_no_teams(inputs)
	if (locale === "pl") return pl_admin_no_teams(inputs)
	if (locale === "uk") return uk_admin_no_teams(inputs)
	if (locale === "hi") return hi_admin_no_teams(inputs)
	if (locale === "ar") return ar_admin_no_teams(inputs)
	if (locale === "ms") return ms_admin_no_teams(inputs)
	if (locale === "bn") return bn_admin_no_teams(inputs)
	if (locale === "zh-TW") return zh_tw2_admin_no_teams(inputs)
	if (locale === "zh-HK") return zh_hk2_admin_no_teams(inputs)
	if (locale === "ur") return ur_admin_no_teams(inputs)
	if (locale === "fa") return fa_admin_no_teams(inputs)
	if (locale === "sw") return sw_admin_no_teams(inputs)
	if (locale === "nl") return nl_admin_no_teams(inputs)
	return en_admin_no_teams(inputs)
});